/* global gtag */
import { useCallback, useContext } from 'react';
import AppContext from '../components/context/AppContext';
import useIsRendered from './useIsRendered';

export default function useFireGtagEvent() {
    const { appContext } = useContext(AppContext);
    const { isRendered } = useIsRendered();

    const gTagId = appContext?.config?.gTagId;
    const fireGA4Event = useCallback(() => {
        if (isRendered) {
            return (eventName, eventParams) => {
                try {
                    if (typeof gtag === 'function' && gTagId) {
                        gtag('event', eventName, eventParams);
                        console.log('GA4 event fired:', eventName);
                    }
                } catch (e) {
                    console.error('Error firing GA4 event', e);
                }
            };
        } else {
            return () => {};
        }
    }, [gTagId, isRendered]);
    return fireGA4Event;
}